<template>
  <div>
    <div class="content">
      <div class="container-fluid">
        <transition name="fade" mode="out-in">
          <div v-loading="loading">
            <div class="card">
              <div class="card-body">
                <div
                  v-for="section,key_section in constants.STORY_DISPLAY_SECTIONS"
                  :key="key_section">
                  <h1 class="h2">
                    {{ section.label }}
                  </h1>
                  <div class="table-responsive">
                    <table v-if="loading == false" class="rules table table-hover">
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                          <th>Publié le</th>
                          <th>Depuis</th>
                          <th>Type</th>
                          <th style="width: 50%;">Titre</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="pointer"
                          @click="toStory(story.id)"
                          v-for="(story,key_contents) in contentsHome[key_section]"
                          :key="key_contents">
                          <td>
                            {{ key_contents + 1 }}.
                          </td>
                          <td>
                            <el-image
                              style="width: 40px; height: 40px"
                              :src="'thumb_story_list' | thumbnail(story)"
                              fit="contain"></el-image>
                          </td>
                          <td>
                            {{ story.published_at | formatDate('DD-MM-YYYY à HH:mm') }}
                          </td>
                          <td>
                            {{ story.published_at | fromNowDate }}
                          </td>
                          <td>
                            {{ $t(`story.${story.scheme}`) }}
                          </td>
                          <td  style="width: 50%;">
                            <small v-if="story.primary_category">
                              {{ story.primary_category.label }}
                            </small>
                            <br>
                            {{ story.title }}
                            <div v-if="story.publication_rules.length > 0">
                              <p v-for="rule in story.publication_rules">
                                <small>
                                  <i class="fa fa-clock-o"></i>
                                  <b>{{ rule.section | translate }}</b>
                                  du <b>{{ rule.start_at| formatDateUTC('DD-MM-YYYY à HH:mm') }}</b>
                                  au <b>{{ rule.end_at| formatDateUTC('DD-MM-YYYY à HH:mm') }}</b>
                                </small>
                              </p>
                            </div>
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                    <p v-if="loading == false && contentsHome[key_section].length == 0" class="text-center text-muted">
                      <em>
                        Pas d’élement pour le moment
                      </em>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <pre>{{ contesntsHome }}</pre> -->
            <!-- <pre>{{ constants }}</pre> -->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    constants: 'constants',
    contentsHome: 'contentsHome'
  }),
  components: {},
  data () {
    return {
      loading: true,
      edit: false,
      mask: 'SECTION_HERO{id,slug,title,thumb_story_list,scheme,published_at,primary_category{label},publication_rules,created_at},' +
      'SECTION_HIGHLIGHTED_STORIES{id,slug,title,thumb_story_list,headline,extract_home,scheme,published_at,primary_category{label},publication_rules,created_at},' +
      'SECTION_LASTEST_STORIES{id,slug,title,thumb_story_list,scheme,published_at,primary_category{label},publication_rules,created_at},' +
      'SECTION_PROGRAMS_CAROUSEL{id,slug,title,thumb_story_list,scheme,published_at,primary_category{label},publication_rules,created_at}' +
      'SECTION_LASTEST_PROGRAMS{id,slug,title,thumb_story_list,scheme,published_at,primary_category{label},publication_rules,created_at}' +
      'SECTION_LIVE{id,slug,title,thumb_story_list,scheme,published_at,primary_category{label},publication_rules,created_at}'
    }
  },
  watch: {
    '$route' (to, from) {
      this.edit = to.query.edit
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.$route.query.edit) {
        this.edit = this.$route.query.edit
      }
      this.$store.dispatch('getConstants', {
        params: {
          'keys': 'STORY_DISPLAY_SECTIONS',
        }
      }).then(() => {
        this.$store.dispatch('getContentsHome', {
          headers: {
            'X-Fields': this.mask
          }
        }).then(() => {
          this.loading = false
        })
      })

    },
    toStory (storyId) {
      this.$router.push({
        name: 'story',
        params: {id: storyId}
      })
    }
  }
}
</script>
<style scoped>

table.rules td {
  vertical-align: top;
}


</style>
